
const Segmented = ({ options = [], value, onChange, label, className = '' }) => (
  <div className={['segmented', className].filter(Boolean).join(' ')} role="radiogroup" aria-label={label}>
    {options.map((option) => {
      const selected = option === value;

      return (
        <button
          key={option}
          type="button"
          role="radio"
          aria-checked={selected}
          className={['segmented__option', selected ? 'is-selected' : ''].filter(Boolean).join(' ')}
          onClick={() => onChange(option)}
        >
          {option}
        </button>
      );
    })}
  </div>
);

export default Segmented;
